import { Attribute } from '../types';

export const CATEGORY_ATTRIBUTES: Record<string, Attribute[]> = {
  // Reliance moved to dynamic DB attributes (SiteSettings)
};
